
function createCookie(name, value, days) {
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		var expires = "; expires=" + date.toGMTString();
	}
	else var expires = "";
	document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

function eraseCookie(name) {
	createCookie(name, "", -1);
}

/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();
	
	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
	
	jQuery('img').on("error", function() {
	  jQuery(this).addClass('broken');
	});
	
	if (jQuery('.redirect-reveal').length) {
		jQuery('.redirect-reveal').foundation('open');
	}

	jQuery(document).on('click', 'a.disclaimer-agree', function(e) {
		e.preventDefault();
		var post_id = jQuery(this).data('post_id');
		createCookie('disclaimer-status_' + post_id, 'agree');
		location.href = location.href;
	});

	jQuery(document).on('click', 'a.disclaimer-disagree', function(e) {
		e.preventDefault();
		var post_id = jQuery(this).data('post_id');
		createCookie('disclaimer-status_' + post_id, 'disagree');
		location.href = location.href;
	});
}); 

